import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=0b8fc09e&scoped=true"
import script from "./FormGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGroup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=0b8fc09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fc09e",
  null
  
)

export default component.exports